import Vue from 'vue';
import VueRouter from "vue-router";
import Meta from 'vue-meta';
import store from '../store';
import GeneralRoutes from './general';
import AdminRoutes from './admin';
import UserRoutes from './user';
import ClubRoutes from './club';
import { applySeo } from '../seo';


Vue.use(VueRouter)
Vue.use(Meta)

var allRoutes = []

allRoutes = allRoutes.concat(
    GeneralRoutes,
    AdminRoutes,
    UserRoutes,
    ClubRoutes

)


const routes = allRoutes;

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
  function findrouteAuthLevel_in_UserAuthLevel(arr1, arr2) {
    return arr1.some(item => arr2.includes(item))
  }

  const meta = to.meta || {};
  const requiresAuth = meta.requiresAuth === true || meta.requiresClubAuth === true || meta.requiresAdminAuth === true;
  const routeAuthLevel = Array.isArray(meta.authLevels) ? meta.authLevels : [];
  const userAuthLevel = store.getters['UserAuth/GET_AUTH_LEVEL'] || []; // Auch für Club

  // Auth nicht erforderlich -> weiter
  if (!requiresAuth) {
    return next();
  }

  // Auth erforderlich: Prüfe Berechtigung
  if (routeAuthLevel.length === 0 || findrouteAuthLevel_in_UserAuthLevel(routeAuthLevel, userAuthLevel)) {
    // Zusätzliche Feature-Prüfung für Club-Routen
    if (meta.requiresClubAuth && meta.feature) {
      const clubCan = store.getters['ClubAuth/clubCan'];
      if (!clubCan[meta.feature]) {
        return next({ path: '/club/home' });
      }
    }
    // Zusätzliche Feature-Prüfung für User-Routen
    if (meta.requiresAuth && meta.userFeature) {
      const userCan = store.getters['UserAuth/userCan'];
      if (!userCan[meta.userFeature]) {
        return next({ path: '/user/home' });
      }
    }
    return next();
  }

  // Keine Berechtigung / Session abgelaufen -> Redirect mit Rückkehrziel
  next({ path: '/login', query: { redirect: to.fullPath } })
});

router.afterEach(to => applySeo(to));

/*
 * Nach einem neuen Release kennt ein offener Tab (oder ein alter Stand im
 * Browser-Cache) noch Chunks, die es auf dem Server nicht mehr gibt. Der
 * Router bricht dann still ab und das Menü wirkt tot. Stattdessen einmal
 * direkt die Zielseite laden, damit index.html und app.js frisch kommen.
 * Die Sperre verhindert eine Schleife, falls der Chunk wirklich fehlt.
 */
const CHUNK_RELOAD_KEY = 'chunkReloadAt';
const CHUNK_RELOAD_PAUSE_MS = 10 * 1000;

router.onError(error => {
  const isChunkError = error && (
    error.name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk .+ failed/.test(error.message)
  );
  if (!isChunkError) return;

  try {
    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;
    if (Date.now() - lastReload < CHUNK_RELOAD_PAUSE_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // Ohne sessionStorage keine Sperre möglich, dann lieber nicht neu laden
    return;
  }

  const target = router.history.pending;
  window.location.assign(target ? router.resolve(target).href : window.location.href);
});


// router.beforeEach((to, from, next) => {
//     function findrouteAuthLevel_in_UserAuthLevel(arr1, arr2) {
//         return arr1.some(item => arr2.includes(item))
//     }
//
//     const routeAuthLevel = to.meta.authLevels;
//     const userAuthLevel = store.getters['UserAuth/GET_AUTH_LEVEL']; // Auch für Club
//
//     if (findrouteAuthLevel_in_UserAuthLevel(routeAuthLevel, userAuthLevel)) next();
//     else next('/login')
// });

export default router
